import axios from 'axios'

let _store = null;
let _router = null;

export const setStore = (store) => { _store = store; };
export const setRouter = (router) => { _router = router; };

const instance = axios.create({
    baseURL: import.meta.env.PUBLIC_API_HOST,
    withCredentials: true,
    headers: {
        crossDomain: true,
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Access-Control-Allow-Origin': '*',
    },
});

instance.interceptors.response.use(
    function (response) {
        return response
    },
    function (error) {
        switch (error.response?.status) {
            case 401:
                if (_store) {
                    _store.dispatch('auth/logout')
                }
                if (_router) _router.push('/')
                break;
            case 419:
                instance.request("GET", '/csrf-cookie')
                break;
        }
        return Promise.reject(error);
    });

instance.interceptors.request.use(function (config) {
    const token = _store?.state?.auth?.token;
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

export const useHttp = () => instance
